import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Card, Breadcrumb } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { impactStories } from '../data/impact-stories';

const ImpactStoryDetail = ({ darkMode }) => {
    const { story_id } = useParams();
    const story = impactStories[story_id];

    if (!story) {
        return (
            <Container style={{
                minHeight: '100vh',
                paddingTop: '30px',
                color: darkMode ? '#f8f9fa' : '#212529'
            }}>
                <h2 className="text-center" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                    Story not found
                </h2>
                <p className="text-center">
                    <Link to="/our-impact" style={{ color: '#2E7D32' }}>Back to Our Impact</Link>
                </p>
            </Container>
        );
    }

    const cardStyle = {
        backgroundColor: darkMode ? '#343a40' : '#ffffff',
        color: darkMode ? '#f8f9fa' : '#212529',
        border: darkMode ? '1px solid #495057' : '1px solid #dee2e6'
    };

    return (
        <Container style={{ minHeight: '100vh', paddingTop: '20px', paddingBottom: '30px' }}>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/our-impact" }}>Our Impact</Breadcrumb.Item>
                <Breadcrumb.Item active>{story.title.length > 50 ? story.title.substring(0, 50) + '...' : story.title}</Breadcrumb.Item>
            </Breadcrumb>

            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className="text-center mb-4" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                    {story.title}
                </h2>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
            >
                <Card style={cardStyle} className="shadow mb-4 overflow-hidden">
                    <Card.Img
                        variant="top"
                        src={story.image}
                        alt={story.title}
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                </Card>
            </motion.div>

            {story.sections.map((section, index) => (
                <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                    <Card style={{ ...cardStyle, borderLeft: section.heading ? '4px solid #2E7D32' : 'none' }} className="shadow-sm mb-3">
                        <Card.Body>
                            {section.heading && (
                                <h4 style={{ color: darkMode ? '#A5D6A7' : '#2E7D32', marginBottom: '12px' }}>
                                    {section.heading}
                                </h4>
                            )}
                            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: 0 }}>
                                {section.content}
                            </p>
                        </Card.Body>
                    </Card>
                </motion.div>
            ))}

            <div className="text-center mt-4">
                <Link
                    to="/our-impact"
                    className="btn"
                    style={{
                        backgroundColor: '#2E7D32',
                        color: '#ffffff',
                        border: 'none',
                        padding: '10px 30px'
                    }}
                >
                    ← Back to All Impact Stories
                </Link>
            </div>
        </Container>
    );
};

export default ImpactStoryDetail;
